import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: "app-avatar-cell-renderer",
    template: `
    <div class="tmwf-avatar-cell" *ngIf="hasValue; else emptyTpl">
      <div
        *ngFor="let avatar of avatars"
        class="tmwf-avatar-circle"
        [style.background-color]="avatar.color"
        [matTooltip]="avatar.name"
      >
        {{ avatar.initials }}
      </div>
    </div>
    <ng-template #emptyTpl>
      <span class="tmwf-avatar-empty">- -</span>
    </ng-template>
  `,
    styles: [
        `
           .tmwf-avatar-cell {
             display: flex;
             align-items: center;
             gap: 4px;
             height: 100%;
           }
           .tmwf-avatar-circle {
             width: 30px;
             height: 30px;
             border-radius: 50%;
             display: flex;
             align-items: center;
             justify-content: center;
             color: #fff;
             font-size: 11px;
             font-weight: 600;
             flex-shrink: 0;
             border: 2px solid #fff;
             box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
           }
           .tmwf-avatar-empty {
             color: #9ca3af;
             font-size: 13px;
           }
         `,
    ],
    standalone: false
})
export class AvatarCellRendererComponent implements ICellRendererAngularComp {
  params!: ICellRendererParams;
  hasValue = false;
  avatars: { initials: string; name: string; color: string }[] = [];

  private colorPalette = [
    "#4A90D9",
    "#E8853D",
    "#22c55e",
    "#ef4444",
    "#8b5cf6",
    "#49619D",
    "#f97316",
    "#06b6d4",
  ];

  agInit(params: ICellRendererParams): void {
    this.params = params;
    const val = params.value;

    if (!val || val === "--") {
      this.hasValue = false;
      return;
    }

    this.hasValue = true;
    const names = Array.isArray(val) ? val : [val];

    this.avatars = names.map((name: string, i: number) => {
      const clean = (name || "").trim();
      // For emails ("john.doe@example.com") strip the @-suffix before extracting initials,
      // then split on `.`, `_`, `-`, or whitespace and take the first letter of each part.
      const prefix = clean.split("@")[0] || clean;
      const parts = prefix.split(/[\s._-]+/).filter((p) => p.length > 0);
      const initials =
        parts.length > 1
          ? (parts[0][0] + parts[1][0]).toUpperCase()
          : prefix.substring(0, 2).toUpperCase();

      return {
        initials,
        name: clean,
        color: this.colorPalette[i % this.colorPalette.length],
      };
    });
  }

  refresh(): boolean {
    return false;
  }
}
